var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid mt-2"},[_c('div',{staticClass:"row"},[_c('global-loading'),_c('div',{staticClass:"col-2"},[_c('admin-menu')],1),_c('div',{staticClass:"col-10"},[_c('router-view',{attrs:{"name":"default"}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }